export const CART_STEP_NUMBER = 0
export const ASSIGN_PASSES_STEP_NUMBER = 1
export const WAIVERS_STEP_NUMBER = 2
export const PAYMENT_STEP_NUMBER = 3
export const REVIEW_STEP_NUMBER = 4

const STEP_URLS = {
  [CART_STEP_NUMBER]: '/cart',
  [ASSIGN_PASSES_STEP_NUMBER]: '/assign-passes',
  [WAIVERS_STEP_NUMBER]: '/waiver',
  [PAYMENT_STEP_NUMBER]: '/payment',
  [REVIEW_STEP_NUMBER]: '/payment/review',
}

export function urlFromStep(stepNum: number): string {
  let stepURL = STEP_URLS[stepNum]

  if (!stepURL) {
    console.error(`Invalid step num: ${stepNum}`)
    stepURL = STEP_URLS[CART_STEP_NUMBER]
  }

  return stepURL
}
